<template>
  <div class="timestamp">
    <div class="loading" v-if="loading">
      <vue-loaders-ball-grid-pulse color="#00EF71" size="10px" />
    </div>

    <div v-if="error && error === 'invalid_url'" class="error">
      <Heading type="failure">Invalid Hash</Heading>
      <p>This hash is invalid. SHA-256 hashes are hexadecimal and 64 character long.</p>
    </div>
    <div v-if="error && error === 'timestamp_not_found'" class="error">
      <Heading type="failure">Hash Not Found</Heading>
      <p>This hash was not found and was never posted. Double check that you are looking at the right hash, generated when posting a proof. Another way to find the hash is to enter the exact same message or file again using <router-link to="/verify">Verify</router-link>.</p>
    </div>

    <div v-if="timestamp" class="content">
      <Heading type="success">The hash was found</Heading>
      <p>
        The hash has been posted on
        {{ timestamp.date | momentDate }}.
      </p>
      <pre>{{ timestamp }}</pre>
      <!--
        https://xrpscan.com/tx/6E5CCFEDD8E495CD774CF1BA942CCA8C320A1AEB9D3F288C765A98CE36E8662A
        https://bithomp.com/explorer/C41123B6617ECCD534922A728E618A2528790A78C86B6375CE6B40D932799705
        -----
        https://rinkeby.etherscan.io/tx/0xf0cf6f056b6403d87eb11a70e47c87970b1554de67baf0e902e92b563a8924a7
        https://blockscout.com/eth/rinkeby/tx/0xf0cf6f056b6403d87eb11a70e47c87970b1554de67baf0e902e92b563a8924a7/internal_transactions
        https://enjinx.io/eth/transaction/0x8d4852f115bb9af8b743f01267b4b1bfc67e7448452bb7b14262e13af6bfd0f1
        https://www.etherchain.org/tx/4b066f869b164c331121e16099620ab2bc04f1ca2844a75b4082f333f0c593e2
        https://ethplorer.io/tx/0x4b066f869b164c331121e16099620ab2bc04f1ca2844a75b4082f333f0c593e2
        https://blockchair.com/ethereum/transaction/0x4b066f869b164c331121e16099620ab2bc04f1ca2844a75b4082f333f0c593e2
        -------
        https://www.blockchain.com/btc/tx/6eae1eefc868a957ebead946b8b2e9be7eecd7d6d0f402d192762863c3887c9e?show_adv=true
        https://live.blockcypher.com/btc/tx/6eae1eefc868a957ebead946b8b2e9be7eecd7d6d0f402d192762863c3887c9e/
        https://btc.com/6eae1eefc868a957ebead946b8b2e9be7eecd7d6d0f402d192762863c3887c9e
      -->
      <p v-if="timestamp.released === false">
        It will be included in the next release, #{{timestamp.release}}.
      </p>
      <p v-else>
        It was included in the
        <router-link :to="'/release/' + timestamp.releaseName">
          Release #{{timestamp.releaseName}}</router-link>.
      </p>

    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading.vue'

import moment from 'moment-mini'

export default {
  name: 'Timestamp',
  components: {
    Heading
  },
  data: () => ({
    loading: false,
    timestamp: null,
    error: null
  }),
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  filters: {
    momentDate (date) {
      return moment(date).utc().format('YYYY-MM-DD HH:mm:ss') + ' UTC'
    }
  },
  methods: {
    fetchData: async function () {
      this.error = this.errorReleaseName = this.timestamp = null
      this.loading = true
      try {
        const rawResponse = await fetch(`${process.env.VUE_APP_API}timestamp/${
          this.$route.params.url}`)
        if (rawResponse.ok) {
          this.timestamp = await rawResponse.json()
        } else {
          const json = await rawResponse.json()
          this.error = json.error
        }
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
table {
  width: 100%;
}
th {
  text-align: left;
}
thead th {
  border-bottom: 1px solid #444;
  padding: 4px 0;
  vertical-align: top;
}
tbody td {
  border-bottom: 1px solid #333;
  padding: 4px 0;
  vertical-align: top;
}

tbody tr:last-child td {
  border-bottom: 0;
}
</style>
